import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 16.583 20.5",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_8739",
		"data-name": "Group 8739",
		transform: "translate(0.75 0.75)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_8737",
			"data-name": "Group 8737",
			transform: "translate(0 3)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group_8734",
				"data-name": "Group 8734",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_8736",
					"data-name": "Group 8736",
					children: /* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14443",
						"data-name": "Rectangle 14443",
						width: 12,
						height: 16,
						rx: 2,
						fill: "#dad9ef",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1.5
					})
				})
			})
		}), /* @__PURE__ */ _jsx("g", {
			id: "Group_8735",
			"data-name": "Group 8735",
			transform: "translate(3.083)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group_8734-2",
				"data-name": "Group 8734",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_8736-2",
					"data-name": "Group 8736",
					children: /* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14443-2",
						"data-name": "Rectangle 14443",
						width: 12,
						height: 16,
						rx: 2,
						fill: "#dad9ef",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1.5
					})
				})
			})
		})]
	})
});
export default SvgCopy;
